// 引入骑行相关的接口文件
import * as bikelist from './bike'
// import * as useralllist from './userall'
// 对外暴露
export default {
  bikelist
}
